import React from 'react';

import {
	AVAILABILITY_STATUS_IDLE,
	AVAILABILITY_STATUS_ON_ABSENCE,
	AVAILABILITY_STATUS_ON_ASSIGNMENT,
	AVAILABILITY_STATUS_ON_PROTECTION,
	AVAILABILITY_STATUS_RESTING,
	AVAILABILITY_STATUS_UNKNOWN,
} from './const';

import styles from './styles.module.css';

const STATUS_MAP = {
	idle: { label: AVAILABILITY_STATUS_IDLE, className: styles.idle },
	onassignment: { label: AVAILABILITY_STATUS_ON_ASSIGNMENT, className: styles.assignment },
	onabsence: { label: AVAILABILITY_STATUS_ON_ABSENCE, className: styles.absence },
	onprotection: { label: AVAILABILITY_STATUS_ON_PROTECTION, className: styles.protection },
	resting: { label: AVAILABILITY_STATUS_RESTING, className: styles.resting },
	unknown: { label: AVAILABILITY_STATUS_UNKNOWN, className: styles.unknown },
};

const AvailabilityStatusBadge = ({ driverStatus }) => {
	const { status, activityType, isWAStatus } = driverStatus;

	if (!status) return null;
	const config = STATUS_MAP[activityType];

	const displayLabel = isWAStatus && activityType ? status : config.label;

	if (!config) return <span className={styles.badge}>{displayLabel}</span>;

	return <span className={`${styles.badge} ${config.className}`}>{displayLabel}</span>;
};

export default AvailabilityStatusBadge;
